import React, { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import Spinner from '../../layout/Spinner';
import { authRoute, localToken } from '../../utils/constants';

const ShowPageAdsVolumeFromDB = (props) => {
  const { pageId } = props;
  const [adsVolume, setAdsVolume] = useState(null);
  useEffect(() => {
    try {
      axios
        .post(
          `${authRoute}/alternativePages/getPageAdsVolumeFromDB`,
          { pageId },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Baerer ${localToken}`,
            },
          }
        )
        .then((res) => {
          setAdsVolume(res.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);
  console.log({ adsVolume });
  return typeof adsVolume === 'number' ? (
    <div>
      <span>{adsVolume?.error?.error ? <>{adsVolume.error.error.message}</> : null}</span>
      <span>{adsVolume}</span>
    </div>
  ) : (
    <Spinner />
  );
};

export default ShowPageAdsVolumeFromDB;
